module.exports = ImageCompressor;